import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue";
import _imports_0 from '@/assets/img/logo_white.png';
const _hoisted_1 = {
  key: 0,
  class: "logo has-multi-column"
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1);
const _hoisted_3 = [_hoisted_2];
const _hoisted_4 = {
  class: "header-main"
};
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "一体化智慧粮库系统", -1);
const _hoisted_6 = {
  key: 0,
  class: "top-menu-container"
};
const _hoisted_7 = ["onClick"];
const _hoisted_8 = {
  class: "header-menu",
  style: {
    "flex-grow": "1"
  }
};
const _hoisted_9 = ["src"];
const _hoisted_10 = {
  class: "el-dropdown-link"
};
const _hoisted_11 = {
  class: "layout-content"
};
const _hoisted_12 = {
  key: 0,
  class: "tag-wrap"
};
import { BellFilled } from '@element-plus/icons-vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import { useRouter, useRoute } from 'vue-router';
import defaultHeaderImg from '@/assets/img/default-header.jpg';
import { getToken, setToken, arrayToTree, getAppId } from '@/common/utils/index';
import { useLayoutStore, useLoginStore, useMessage } from '@/store';
import { SysMenuBindType, SysOnlineFormType } from '@/common/staticDict';
import LoginController from '@/api/system/LoginController';
import OAuthController from '@/api/system/OAuthController';
import { useUpload } from '@/common/hooks/useUpload';
import { useCommon } from '@/common/hooks/useCommon';
import DinkTalkLogin from '@/components/DingTalk/login.vue';
import FeishuLogin from '@/components/Feishu/login.vue';
import WeWorkLogin from '@/components/WeWork/login.vue';
import WeChatLogin from '@/components/WeChat/login.vue';
import Sidebar from './components/Sidebar.vue';
import TagPanel from './components/TagPanel.vue';
import FormModifyPassword from './components/formModifyPassword/index.vue';
import FormModifyHeadImage from './components/formModifyHeadImage/index.vue';
import KeepAliveRouterView from './components/KeepAliveRouterView.vue';

import { inject, ref, computed, watch, onMounted, onBeforeUnmount } from 'vue';
const __default__ = {
  name: 'Layout'
};
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {
    const {
      Dialog
    } = useCommon();
    const router = useRouter();
    const route = useRoute();
    const layoutStore = useLayoutStore();
    const loginStore = useLoginStore();
    const documentClientHeight = inject('documentClientHeight', ref(500));
    const projectName = process.env.VUE_APP_PROJECT_NAME;
    const {
      getUploadFileUrl
    } = useUpload();
    const menuList = ref([]);
    const menuType = ref('sgsm_worker');
    const showHeader = ref(true);
    const userInfo = loginStore.userInfo;
    // TODO 切换菜单会触发该方法？
    // 用户头像
    const headerImg = computed(() => {
      if (userInfo && userInfo.headImageUrl) {
        let temp = getUploadFileUrl(userInfo.headImageUrl, {
          filename: userInfo.headImageUrl.filename
        });
        return temp;
      } else {
        return null;
      }
    });
    // 消息数量
    const messageStore = useMessage();
    const messageCount = computed(() => {
      return messageStore.messageCount || {};
    });
    // TODO 监听当前菜单变化，跳转到目标路由
    watch(() => layoutStore.currentMenu, (newVal, oldVal) => {
      console.log('当前页发生变化', newVal, oldVal);
      if (newVal != oldVal) {
        jumpTo(newVal);
      }
      // else {
      //   if (route.name != layoutStore.indexName) {
      //     router.replace({
      //       name: layoutStore.indexName,
      //     });
      //   }
      // }
    });
    const oauthBindInfo = ref([]);
    const formatActive = menu => {
      if (menu.code === menuType.value) {
        return 'active';
      } else {
        return '';
      }
    };
    const changeModule = menu => {
      getUserTree();
      router.push({
        path: menu.router,
        query: {
          menuCode: menu.code
        }
      });
    };
    const loadOAuthBindInfo = () => {
      OAuthController.getBindInfo().then(res => {
        oauthBindInfo.value = res.data;
      }).catch(e => {
        console.error(e);
      });
    };
    const showOAuthItem = source => {
      for (let index = 0; index < oauthBindInfo.value.length; index++) {
        const element = oauthBindInfo.value[index];
        if (element.source === source) {
          return true;
        }
      }
      return false;
    };
    // 路由跳转
    function jumpTo(menuItem) {
      if (menuItem != null) {
        // 路由菜单
        if (menuItem.bindType === SysMenuBindType.ROUTER && menuItem.formRouterName != null && menuItem.formRouterName !== '') {
          router.replace({
            name: menuItem.formRouterName
          });
          return;
        }
        // 在线表单菜单
        if (menuItem.bindType === SysMenuBindType.ONLINE_FORM && menuItem.onlineFormId != null && menuItem.onlineFormId !== '') {
          router.replace({
            name: 'onlineForm',
            query: {
              formId: menuItem.onlineFormId,
              formType: SysOnlineFormType.QUERY
            }
          });
          return;
        }
        // 工单列表菜单
        if (menuItem.bindType === SysMenuBindType.WORK_ORDER && menuItem.onlineFormId != null && menuItem.onlineFormId !== '' && menuItem.onlineFlowEntryId != null && menuItem.onlineFlowEntryId !== '') {
          router.replace({
            name: 'onlineForm',
            query: {
              formId: menuItem.onlineFormId,
              entryId: menuItem.onlineFlowEntryId,
              formType: SysOnlineFormType.WORK_ORDER
            }
          });
          return;
        }
        // 报表菜单
        if (menuItem.bindType === SysMenuBindType.REPORT && menuItem.reportPageId != null && menuItem.reportPageId !== '') {
          router.replace({
            name: 'reportRender',
            query: {
              pageId: menuItem.reportPageId
            }
          });
          return;
        }
        // 外部链接
        if (menuItem.bindType === SysMenuBindType.THRID_URL && menuItem.targetUrl != null && menuItem.targetUrl !== '') {
          let token = getToken();
          let targetUrl = menuItem.targetUrl;
          if (targetUrl.indexOf('?') === -1) {
            targetUrl = targetUrl + '?';
          }
          targetUrl = targetUrl + 'token=' + token;
          window.open(targetUrl);
          return;
        }
      }
      console.warn('没有匹配到目标路由');
      if (route.name !== layoutStore.indexName) {
        router.replace({
          name: layoutStore.indexName
        });
      }
    }
    const getMainStyle = computed(() => {
      return [{
        height: documentClientHeight.value + 'px'
      }];
    });
    const getContextStyle = computed(() => {
      return [{
        height: documentClientHeight.value - (layoutStore.supportTags ? 108 : 60) + 'px'
      }];
    });
    const getRouterViewStyle = computed(() => {
      return [{
        'min-height': documentClientHeight.value - (layoutStore.supportTags ? 108 : 60) - 32 + 'px'
      }];
    });
    const handleMessage = command => {
      router.push({
        name: 'formMessage',
        query: {
          type: command
        }
      });
    };
    const handleCommand = command => {
      switch (command) {
        case 'logout':
          ElMessageBox.confirm('是否退出登录？', '', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            LoginController.logout().then(() => {
              ElMessage({
                type: 'success',
                message: '退出成功'
              });
              setToken(null);
              router.replace('/login');
            }).catch(e => {
              console.log(e);
              ElMessage({
                type: 'error',
                message: e
              });
            });
          }).catch(() => {
            console.log('取消退出');
          });
          break;
        case 'modifyPassword':
          Dialog.show('修改密码', FormModifyPassword, {
            area: '500px'
          }, {}).catch(e => {
            console.warn(e);
          });
          break;
        case 'modifyHeadImage':
          Dialog.show('修改头像', FormModifyHeadImage, {
            area: '500px'
          }, {});
          break;
        case 'bindDingTalk':
          Dialog.show('绑定钉钉', DinkTalkLogin, {
            area: ['400px']
          }, {
            bindSocial: true
          }).then(() => {
            loadOAuthBindInfo();
          }).catch(e => {
            console.warn(e);
          });
          break;
        case 'bindWework':
          Dialog.show('绑定企微', WeWorkLogin, {
            area: ['400px']
          }, {
            bindSocial: true
          }).then(() => {
            loadOAuthBindInfo();
          }).catch(e => {
            console.warn(e);
          });
          break;
        case 'bindFeiShu':
          Dialog.show('绑定飞书', FeishuLogin, {
            area: ['400px']
          }, {
            bindSocial: true
          }).then(() => {
            loadOAuthBindInfo();
          }).catch(e => {
            console.warn(e);
          });
          break;
        case 'bindWechat':
          Dialog.show('绑定微信', WeChatLogin, {
            area: ['400px']
          }, {
            bindSocial: true
          }).then(() => {
            loadOAuthBindInfo();
          }).catch(e => {
            console.warn(e);
          });
          break;
        default:
          ElMessage.warning(`click on item `);
          break;
      }
    };
    const getUserTree = () => {
      let appId = getAppId();
      if (appId === 'os') {
        LoginController.getUserTree({
          appCode: 'SGSM'
        }).then(res => {
          if (res.data) {
            var query = route.query;
            if (query.menuCode) {
              menuType.value = query.menuCode;
            }
            let menuTree = arrayToTree(res.data);
            if (menuTree && menuTree[0]) {
              menuList.value = menuTree[0].children.filter(item => item.children.length);
              let arr = menuList.value.filter(item => item.code === 'sgsm_worker')[0].children;
              arr.forEach(item => {
                item.menuName = item.name;
                item.menuId = item.id;
                item.children.forEach(child => {
                  child.menuName = child.name;
                  child.parentId = child.pid;
                  child.menuId = child.id;
                  child.formRouterName = child.router.split('/')[2];
                });
              });
              layoutStore.setMenuList(arr);
            }
          }
        });
      }
    };
    onMounted(() => {
      if (window.frameElement && window.frameElement.tagName === 'IFRAME') {
        showHeader.value = false;
      }
      getUserTree();
      messageStore.startMessage();
      // 加载OAuth绑定信息
      loadOAuthBindInfo();
    });
    onBeforeUnmount(() => {
      messageStore.stopMessage();
    });
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_badge = _resolveComponent("el-badge");
      const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
      const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
      const _component_el_dropdown = _resolveComponent("el-dropdown");
      const _component_el_header = _resolveComponent("el-header");
      const _component_el_aside = _resolveComponent("el-aside");
      const _component_el_scrollbar = _resolveComponent("el-scrollbar");
      const _component_el_main = _resolveComponent("el-main");
      const _component_el_container = _resolveComponent("el-container");
      return _openBlock(), _createBlock(_component_el_container, {
        class: _normalizeClass('container-' + _ctx.defaultFormItemSize),
        style: _normalizeStyle(_unref(getMainStyle))
      }, {
        default: _withCtx(() => [_createVNode(_component_el_container, {
          style: {
            "background-color": "#f5f8f9"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_header, {
            class: _normalizeClass(["header", _unref(layoutStore).supportColumn ? 'multi-column-header' : '']),
            style: {
              "padding": "0"
            }
          }, {
            default: _withCtx(() => [_unref(layoutStore).supportColumn ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_4, [_hoisted_5, _unref(showHeader) ? (_openBlock(), _createElementBlock("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menuList), (item, index) => {
              return _openBlock(), _createElementBlock("div", {
                key: 'menu-' + index,
                class: _normalizeClass(['menu', formatActive(item)]),
                onClick: $event => changeModule(item)
              }, _toDisplayString(item.name), 11, _hoisted_7);
            }), 128))])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_8, [_createVNode(_component_el_dropdown, {
              class: "message-dropdown",
              trigger: "click",
              style: {
                "align-items": "center",
                "justify-content": "center"
              },
              onCommand: handleMessage
            }, {
              dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, {
                style: {
                  "min-width": "130px"
                }
              }, {
                default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
                  class: "user-dropdown-item",
                  command: "remindingMessage"
                }, {
                  default: _withCtx(() => [_createTextVNode(" 催办消息 "), _createVNode(_component_el_badge, {
                    value: _unref(messageCount).remindingMessageCount,
                    hidden: !_unref(messageCount).remindingMessageCount || _unref(messageCount).remindingMessageCount <= 0
                  }, null, 8, ["value", "hidden"])]),
                  _: 1
                }), _createVNode(_component_el_dropdown_item, {
                  class: "user-dropdown-item",
                  command: "copyMessage"
                }, {
                  default: _withCtx(() => [_createTextVNode(" 抄送消息 "), _createVNode(_component_el_badge, {
                    value: _unref(messageCount).copyMessageCount,
                    hidden: !_unref(messageCount).copyMessageCount || _unref(messageCount).copyMessageCount <= 0
                  }, null, 8, ["value", "hidden"])]),
                  _: 1
                })]),
                _: 1
              })]),
              default: _withCtx(() => [_createVNode(_component_el_badge, {
                "is-dot": "",
                hidden: !_unref(messageCount).totalCount || _unref(messageCount).totalCount <= 0,
                style: {
                  "height": "22px",
                  "line-height": "22px",
                  "cursor": "pointer"
                }
              }, {
                default: _withCtx(() => [_createVNode(_component_el_icon, {
                  style: {
                    "font-size": "22px",
                    "color": "#fff"
                  }
                }, {
                  default: _withCtx(() => [_createVNode(_unref(BellFilled))]),
                  _: 1
                })]),
                _: 1
              }, 8, ["hidden"])]),
              _: 1
            }), _createElementVNode("img", {
              src: _unref(headerImg) ? _unref(headerImg) : _unref(defaultHeaderImg),
              class: "header-img"
            }, null, 8, _hoisted_9), _createVNode(_component_el_dropdown, {
              class: "user-dropdown",
              trigger: "click",
              onCommand: handleCommand
            }, {
              dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
                default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
                  class: "user-dropdown-item",
                  command: "modifyPassword"
                }, {
                  default: _withCtx(() => [_createTextVNode("修改密码")]),
                  _: 1
                }), _createVNode(_component_el_dropdown_item, {
                  class: "user-dropdown-item",
                  command: "modifyHeadImage"
                }, {
                  default: _withCtx(() => [_createTextVNode("修改头像")]),
                  _: 1
                }), _createVNode(_component_el_dropdown_item, {
                  class: "user-dropdown-item",
                  command: "logout"
                }, {
                  default: _withCtx(() => [_createTextVNode("退出登录")]),
                  _: 1
                })]),
                _: 1
              })]),
              default: _withCtx(() => [_createElementVNode("span", _hoisted_10, _toDisplayString((_unref(userInfo) || {}).showName), 1)]),
              _: 1
            })])])]),
            _: 1
          }, 8, ["class"]), _createVNode(_component_el_main, {
            class: "layout-main"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_aside, {
              width: _unref(layoutStore).collapsed ? _unref(layoutStore).supportColumn ? '80px' : '64px' : _unref(layoutStore).supportColumn ? '280px' : '204px',
              class: "sidebar"
            }, {
              default: _withCtx(() => [_createVNode(Sidebar, {
                style: {
                  "overflow": "hidden"
                }
              })]),
              _: 1
            }, 8, ["width"]), _createElementVNode("div", _hoisted_11, [_unref(layoutStore).supportTags ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createElementVNode("i", {
              class: _normalizeClass(["online-icon", _unref(layoutStore).collapsed ? 'icon-expand' : 'icon-unexpand']),
              style: {
                "font-size": "16px",
                "color": "#333",
                "cursor": "pointer"
              },
              onClick: _cache[0] || (_cache[0] = () => _unref(layoutStore).toggleCollapsed())
            }, null, 2), _createVNode(TagPanel)])) : _createCommentVNode("", true), _createVNode(_component_el_scrollbar, {
              "wrap-class": "scrollbar_dropdown__wrap",
              style: _normalizeStyle(_unref(getContextStyle))
            }, {
              default: _withCtx(() => [_createVNode(KeepAliveRouterView, {
                class: "page-box",
                style: _normalizeStyle([{
                  "overflow": "hidden",
                  "margin": "16px"
                }, _unref(getRouterViewStyle)])
              }, null, 8, ["style"])]),
              _: 1
            }, 8, ["style"])])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["class", "style"]);
    };
  }
});